module.exports = __webpack_public_path__ + "static/media/Playground.5aa80335.png";